import React from "react";
import { Link } from "react-router-dom";
import { Calculator } from "lucide-react";

export default function Header() {
    return (
        <header className="border-b border-slate-200 bg-white/80 backdrop-blur-sm sticky top-0 z-40">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-2 group" data-testid="brand-home-link">
                    <div className="h-9 w-9 rounded-full bg-[#1E3A8A] flex items-center justify-center text-white">
                        <Calculator className="h-5 w-5" />
                    </div>
                    <div className="leading-tight">
                        <div className="font-heading font-bold text-[#0F172A] text-base sm:text-lg">CCS Cost Calculator</div>
                        <div className="text-xs text-slate-500 -mt-0.5">Australia</div>
                    </div>
                </Link>
                <nav className="flex items-center gap-2 sm:gap-4 text-sm">
                    <Link to="/" className="text-slate-600 hover:text-[#1E3A8A] transition-colors px-2 py-1" data-testid="nav-home">Home</Link>
                    <Link to="/calculator" className="text-slate-600 hover:text-[#1E3A8A] transition-colors px-2 py-1" data-testid="nav-calculator">Calculator</Link>
                </nav>
            </div>
        </header>
    );
}
